import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import SendNotification from "./SendNotification";
import SendSchoolNotification from "./SendSchoolNotification";

const Notification = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className="content-wrapper">
      <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
        <div className="container-fluid">
          <h4 className="m-0">Notifications</h4>
        </div>
      </div>

      <Box sx={{ borderBottom: 1, borderColor: "divider", px: 2 }}>
        <Tabs value={tabValue} onChange={handleChange}>
          <Tab label="Send Notification" />
          <Tab label="Send School Notification" />
        </Tabs>
      </Box>

      <Box sx={{ p: 2 }}>
        {tabValue === 0 && <SendNotification />}
        {tabValue === 1 && <SendSchoolNotification />}
      </Box>
    </div>
  );
};

export default Notification;
